export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/index.ts